import { render, staticRenderFns } from "./BbppNoticiasOrigenAlDia.vue?vue&type=template&id=2d993b2a"
import script from "./BbppNoticiasOrigenAlDia.vue?vue&type=script&lang=js"
export * from "./BbppNoticiasOrigenAlDia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports